import surfaceproduct1 from "../../../images/productsImages/surfaceImages/Industrial/Bombassuperficie/AUTOCEBANTES/pioneerGS.jpg";
import surfaceproduct2 from "../../../images/productsImages/surfaceImages/Industrial/Bombassuperficie/Caracol/SerieAG.jpg";
import surfaceproduct3 from "../../../images/productsImages/surfaceImages/Industrial/Bombassuperficie/Caracol/SERIED-01.png";
import surfaceproduct5 from "../../../images/productsImages/surfaceImages/Industrial/Bombassuperficie/Cascasapartida/HDaserie340wilo.jpg";
import surfaceproduct6 from "../../../images/productsImages/surfaceImages/Industrial/Bombassuperficie/Multietapa/SerieCVI.jpg";
import surfaceproduct7 from "../../../images/productsImages/surfaceImages/Industrial/Bombassuperficie/Multietapa/SerieVR.jpg";
import surfaceproduct8 from "../../../images/productsImages/surfaceImages/Industrial/Bombassuperficie/Multietapa/GrundfosSerieCR.jpg";
import surfaceproduct10 from "../../../images/productsImages/surfaceImages/Industrial/Bombassuperficie/Multietapa/multietapaSB.jpg";
import surfaceproduct11 from "../../../images/productsImages/surfaceImages/Industrial/Bombassuperficie/TipoANSI/FIT.jpg";
import surfaceproduct12 from "../../../images/productsImages/surfaceImages/Industrial/Bombassuperficie/TipoANSI/OSDserie460.jpg";
import surfaceproduct13 from "../../../images/productsImages/surfaceImages/Industrial/Motoressuperficie/BALDOR/AcomplamientoJM2Baldor.png";
import surfaceproduct14 from "../../../images/productsImages/surfaceImages/Industrial/Motoressuperficie/BALDOR/AcomplamientoJM-baldor.png";
import surfaceproduct15 from "../../../images/productsImages/surfaceImages/Industrial/Motoressuperficie/GENERALELECTRIC/NEMAPremium.png";
import surfaceproduct16 from "../../../images/productsImages/surfaceImages/Industrial/Motoressuperficie/GENERALELECTRIC/Motores.png";
import pdf1 from "../../../pdf/surface/industrial/PioneerGS.pdf";
import pdf2 from "../../../pdf/surface/industrial/AG.pdf";
import pdf3 from "../../../pdf/surface/industrial/SERIED.pdf";
import pdf5 from "../../../pdf/surface/industrial/serieHD.pdf";
import pdf6 from "../../../pdf/surface/industrial/CVI.pdf";
import pdf7 from "../../../pdf/surface/industrial/VR.pdf";
import pdf8 from "../../../pdf/surface/industrial/GRUNDFOS.pdf";
import pdf10 from "../../../pdf/surface/industrial/SerieSB-SBI.pdf";
import pdf11 from "../../../pdf/surface/industrial/fit.pdf";
import pdf12 from "../../../pdf/surface/industrial/OSD.pdf";
import pdf15 from "../../../pdf/surface/industrial/UltraVerticalSeries_GEA.pdf";
import pdf16 from "../../../pdf/surface/industrial/TEFCGeneralPurpose.pdf";

const fe = "Franklin Electric";

const surfaceIndustrialProductList = [
  {
    _id: "surcatindbom001a",
    image: surfaceproduct1,
    title: "Bombas autocebantes serie GS",
    code: "",
    category: "Bombas Superficie",
    brand: fe,
    subcategory: "Autocebantes",
    downLoad: pdf1,
  },
  {
    _id: "surcatindbom002a",
    image: surfaceproduct2,
    title: "Bomba centrífuga serie AG",
    code: "",
    category: "Bombas Superficie",
    brand: fe,
    subcategory: "Caracol",
    downLoad: pdf2,
  },
  {
    _id: "surcatindbom002b",
    image: surfaceproduct3,
    title: "Bomba centrífuga horizontal serie D",
    code: "",
    category: "Bombas Superficie",
    brand: fe,
    subcategory: "Caracol",
    downLoad: pdf3,
  },
  {
    _id: "surcatindbom003a",
    image: surfaceproduct5,
    title: "Carcasa partida HD serie 340",
    code: "",
    category: "Bombas Superficie",
    brand: "Wilo",
    subcategory: "Carscasa Partida",
    downLoad: pdf5,
  },
  {
    _id: "surcatindbom004a",
    image: surfaceproduct6,
    title: "Bombas verticales multietapas serie CVI",
    code: "",
    category: "Bombas Superficie",
    brand: fe,
    subcategory: "Multietapa",
    downLoad: pdf6,
  },
  {
    _id: "surcatindbom004b",
    image: surfaceproduct7,
    title: "Bombas verticales multietapas serie VR",
    code: "",
    category: "Bombas Superficie",
    brand: fe,
    subcategory: "Multietapa",
    downLoad: pdf7,
  },
  {
    _id: "surcatindbom004c",
    image: surfaceproduct8,
    title: "Bombas verticales multietapa serie CR",
    code: "",
    category: "Bombas Superficie",
    brand: "Grundfos",
    subcategory: "Multietapa",
    downLoad: pdf8,
  },
  {
    _id: "surcatindbom004e",
    image: surfaceproduct10,
    title: "Bombas verticales multietapa serie SB, SBI, SBN",
    code: "",
    category: "Bombas Superficie",
    brand: "Speroni",
    subcategory: "Multietapa",
    downLoad: pdf10,
  },
  {
    _id: "surcatindbom005a",
    image: surfaceproduct11,
    title: "Bombas normadas con caja de baleros serie FIT",
    code: "",
    category: "Bombas Superficie",
    brand: fe,
    subcategory: "Tipo ANSI",
    downLoad: pdf11,
  },
  {
    _id: "surcatindbom005b",
    image: surfaceproduct12,
    title: "Bomba de superficie tipo ansi OSD serie 460",
    code: "",
    category: "Bombas Superficie",
    brand: "Wilo",
    subcategory: "Tipo ANSI",
    downLoad: pdf12,
  },
  {
    _id: "surcatindmotbal005a",
    image: surfaceproduct13,
    title: "Motores de bomba de acoplamiento JM, JP, WCP",
    code: "",
    category: "Motores Superficie",
    brand: "Baldor",
    subcategory: "Baldor",
    downLoad: "none",
  },
  {
    _id: "surcatindmotbal005b",
    image: surfaceproduct14,
    title: "Motores de acoplamiento TEFC monofásico y trifásico",
    code: "",
    category: "Motores Superficie",
    brand: "Baldor",
    subcategory: "Baldor",
    downLoad: "none",
  },
  {
    _id: "surcatindmotgl005a",
    image: surfaceproduct15,
    title: "Motores de bombas verticales premium NEMA",
    code: "",
    category: "Motores Superficie",
    brand: "General Electric",
    subcategory: "General Electric",
    downLoad: pdf15,
  },
  {
    _id: "surcatindmotgl005b",
    image: surfaceproduct16,
    title: "Motores de uso general premium NEMA",
    code: "",
    category: "Motores Superficie",
    brand: "General Electric",
    subcategory: "General Electric",
    downLoad: pdf16,
  },
];

export default surfaceIndustrialProductList;
